import Constructor from '../../util/constructor';

const _map = Symbol('fragments');
const _type = Symbol('type');

class Address {

  className: string;
  methodName: string;

  constructor(className: string, methodName: string) {
    this.className = className;
    this.methodName = methodName;
  }
}

class SmartMap<T> {

  [_map] = new Map<string, T>();
  [_type]: Constructor;

  constructor(type: Constructor) {
    this[_type] = type;
  }

  get(key: string): T|null {
    const map = this[_map];

    if (!map.has(key)) {
      map.set(key, new this[_type]());
    }
    return map.get(key) || null;
  }

}

class ComponentEventMap extends SmartMap<Set<Address>> {

  constructor() {
    super(Set);
  }

  insert(type: string, address: Address): void {
    const set = this.get(type);
    set && set.add(address);
  }

}

class FragmentEventMap extends SmartMap<ComponentEventMap> {

  constructor() {
    super(ComponentEventMap);
  }
  
}

class ApplicationEventMap extends SmartMap<FragmentEventMap> {

  constructor() {
    super(FragmentEventMap);
  }

  getComponent(fragment: string, component: string): ComponentEventMap|null {
    const frag = this.get(fragment);
    return frag && frag.get(component);
  }

}

const singleton = new ApplicationEventMap();

export { singleton as default, Address };
